import React from "react";
import "./WelcomeBanner.css";
import { BiChevronsRight } from "react-icons/bi";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const WelcomeBanner1 = ({ data }) => {
  WelcomeBanner1.propTypes = {
    data: PropTypes.array.isRequired, // Replace `object` with the correct type
  };
  return (
    <div
      className="welcome1-banner-bg 
     w-full !bg-[#eef4f9]"
    >
      <div className="container a-container">
        <div className="welcome-container ">
          {data.map((item) => {
            return (
              <div className="row " key={item}>
                <div className="col-md-5 !h-full flex flex-col justify-items-center items-center   welcome-banner-image">
                  <img
                    className="welcome-img-12   md:!h-[300px] pt-[30px]"
                    src={item.img}
                    alt=""
                  />
                </div>
                <div className="col-md-7 d-flex align-items-center welcome-banner-content ">
                  <div className="w-full  pt-[24px] pb-5">
                    <small className=" title !text-left">{item.heading}</small>

                    <h1 className=" heading !normal-case text-left ">
                      {item.subheading}
                    </h1>
                    <div className="w-service my-4">
                      <p className="paragraph text-left ">
                        {/* <i class="fa-solid fa-angles-right me-2"></i> */}
                        <span>
                          <BiChevronsRight style={{ display: "inline" }} />{" "}
                        </span>
                        {item.t1}
                      </p>
                      <p className="paragraph text-left">
                        {/* <i class="fa-solid fa-angles-right me-2"></i>  */}
                        <span>
                          <BiChevronsRight style={{ display: "inline" }} />{" "}
                        </span>
                        {item.t2}
                      </p>
                      <p className="paragraph text-left">
                        {/* <i class="fa-solid fa-angles-right me-2"></i> */}
                        <span>
                          <BiChevronsRight style={{ display: "inline" }} />{" "}
                        </span>
                        {item.t3}
                      </p>
                      <p className="paragraph !text-black text-left">
                        {/* <i class="fa-solid fa-angles-right me-2"></i>  */}
                        <span>
                          <BiChevronsRight style={{ display: "inline" }} />{" "}
                        </span>
                        {item.t4}
                      </p>
                    </div>
                    <div className="text-left">
                      <Link to="/marketplace-help">
                        <button className="!w-fit white-btn !border-[#fae441] ">
                          {item.button}
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WelcomeBanner1;
